/** 성적서/시험성과대비표 선행값(lead) 공통 유틸 — 부자재 서류등록·ADMIN 추출 테스트 동일 */

export const LEAD_LABELS = {
  thickness: '두께 (mm)',
  classification: '등급/분류',
  ft_thick_class: '두께_등급',
  ks2004_thickness: 'KS L 2004 두께',
};

export const LEAD_HELPERS = {
  thickness: '성적서에 표기된 두께(mm)를 입력하세요.',
  classification: '표준에 등록된 등급·분류를 선택하세요.',
  ft_thick_class: '두께와 등급 1단으로 합성됩니다. 직접 입력하지 않습니다.',
  ks2004_thickness: '접합유리 등 레이어 두께를 _ 로 연결해 입력하세요. (예: 3_0.76_3)',
};

export const stripLeadKey = (leadField) => {
  if (!leadField) return null;
  const m = String(leadField).trim().match(/^([a-zA-Z0-9_]+)/);
  return m ? m[1] : null;
};

/** 표준의 GTestComparisons.leadField에서만 수집 (기본 thickness 강제 노출 없음) */
export const collectLeadKeys = (gtestComparisons) => {
  const keys = [];
  const seen = new Set();
  (gtestComparisons || []).forEach((item) => {
    const key = stripLeadKey(item?.leadField);
    if (key && !seen.has(key)) {
      seen.add(key);
      keys.push(key);
    }
  });
  return keys;
};

/** gstandard.classificationComponents → Select 옵션 열 배열 */
export const buildClassificationOptions = (standardDetail) => {
  const comps = standardDetail?.classificationComponents;
  if (!Array.isArray(comps) || !comps.length) return [];
  return comps.map((types, colIdx) => {
    if (!Array.isArray(types)) return [];
    const seen = new Set();
    const opts = [];
    types.forEach((t) => {
      const label = t?.[`type${colIdx}`] ?? t?.type ?? t?.label ?? (typeof t === 'string' ? t : null);
      if (label == null || label === '') return;
      const value = String(label);
      if (seen.has(value)) return;
      seen.add(value);
      opts.push({ label: value, value });
    });
    return opts;
  }).filter((opts) => opts.length > 0);
};

/**
 * 등급/분류 Select 조각을 lead.classification 문자열로 합침.
 * 레거시 인증규격 classifications.type 기본 divider(" ")와 동일해야
 * criterion 키(예: "F형 12.5 E")와 매칭된다.
 */
export const CLASSIFICATION_JOIN_DIVIDER = ' ';

export const joinClassificationParts = (parts, divider = CLASSIFICATION_JOIN_DIVIDER) => (
  (parts || []).filter(Boolean).join(divider)
);

/** 등급 1단(type0). 전체 등급 문자열을 붙이지 않는다. */
const classificationType0 = (data) => {
  const direct = data?.classificationType0;
  if (direct != null && String(direct).trim()) return String(direct).trim();
  const parts = data?.classificationParts;
  if (Array.isArray(parts) && parts[0] != null && String(parts[0]).trim()) {
    return String(parts[0]).trim();
  }
  return '';
};

const synthesizeFtThickClass = (data) => {
  const thick = data.ftThickness != null && String(data.ftThickness).trim() !== ''
    ? data.ftThickness
    : data.thickness;
  const type0 = classificationType0(data);
  if (thick !== undefined && thick !== null && String(thick).trim() !== '' && type0) {
    return { ...data, ft_thick_class: `${thick}_${type0}` };
  }
  return data;
};

/** lead 필수키가 모두 채워졌는지 (ft_thick_class는 두께+등급으로 대체 가능) */
export const areLeadsReady = (leadKeys, leadData) => {
  if (!leadKeys?.length) return true;
  const data = synthesizeFtThickClass({ ...leadData });
  return leadKeys.every((key) => {
    if (key === 'ft_thick_class') {
      return Boolean(data.ft_thick_class && String(data.ft_thick_class).trim());
    }
    const v = data[key];
    return v !== undefined && v !== null && String(v).trim() !== '';
  });
};

/** 분석 API용 lead JSON (ft_thick_class 합성, classification 기본값) */
export const buildLeadJsonData = (leadKeys, leadData) => {
  let data = synthesizeFtThickClass({ ...leadData });
  delete data.ftThickness;
  if (leadKeys.includes('classification') && !data.classification) {
    data = { ...data, classification: 'no_classification' };
  }
  return data;
};
